module.exports = __webpack_public_path__ + "static/fabric-table-dnd-columns-09d28da2b07252308a73e13ad24f65cb.gif";